<template>
  <el-form class="form form__outbox-contact" :model="formData" :rules="rules" ref="form">

    <input-field
      id="name"
      type="text"
      :label="nameLabel"
      :placeholder="namePlaceholder"
      :value="name"
      @input="handleNameChange"
    />

    <input-email-field
      id="email"
      :label="emailLabel"
      :placeholder="emailPlaceholder"
      :value="email"
      @input="handleEmailChange"
    />

    <input-field
      id="phone"
      type="tel"
      :label="phoneLabel"
      :placeholder="phonePlaceholder"
      :value="phone"
      @input="handlePhoneChange"
    />

  </el-form>
</template>

<script>
  import InputField from '@/components/inputs/InputField';
  import InputEmailField from '@/components/inputs/InputEmailField';

  export default {
    name: 'ContactInfoForm',
    data(){
      return {
        rules: {
          email: [
            { required: true, message: this.emailErrorMissing, trigger: 'blur' },
            { type: 'email', message: this.emailErrorWrong, trigger: 'blur,change' }
          ]
        }
      }
    },
    props: [
      'name',
      'namePlaceholder',
      'nameLabel',
      'email',
      'emailPlaceholder',
      'emailLabel',
      'emailErrorMissing',
      'emailErrorWrong',
      'phone',
      'phonePlaceholder',
      'phoneLabel'
    ],
    computed: {
      formData() {
        return {
          name: this.name,
          email: this.email,
          phone: this.phone
        }
      }
    },
    methods: {
      handleNameChange(value, event) { this.$emit('name-change', value); },
      handleEmailChange(value, event) { this.$emit('email-change', value); },
      handlePhoneChange(value, event) { this.$emit('phone-change', value); }
    },
    components: {
      InputField,
      InputEmailField,
    }
  }
</script>

<style lang="scss" scoped>
</style>
